import { seloApostila } from "../../helpers/process.helper";

import { Container } from "./styles";

// Selo "Precisa de apostila" / "Não precisa de apostila" / "A CJ apostila
// por você" ao lado do nome do documento (card do Passo 2 e impressão).
export default function SeloApostila({ nome, familyPlan }) {
  const { tipo, texto } = seloApostila(nome, familyPlan);

  return <Container className={tipo}>{texto}</Container>;
}
